<template>
  <div>
    <vs-button
      type="border"
      color="warning"
      icon="flag"
      @click="activePrompt = true"
      >Cancel Task</vs-button
    >

    <vs-prompt
      class="mt-4 mr-2 shadow-lg"
      type="border"
      color="#7367F0"
      gradient-color-secondary="#0158A3"
      title="Task Cancellation"
      accept-text="Finish"
      cancel-text="Cancel"
      :is-valid="validateForm"
      @accept="submitReason"
      :active.sync="activePrompt"
    >
      <div>
        <form>
          <vs-select class="selectExample w-full" label="Your Reasons" v-model="reason">
            <vs-select-item :key="index" :value="item.reason" :text="item.reason" v-for="(item,index) in options" />
            <vs-select-item :key="0" value="Other" text="Other" />
          </vs-select>
        </form>
        <form>
          <vs-select class="selectExample w-full" label="Cancel Type" v-model="typeData">
            <vs-select-item  value="cancel" text="Normal Cancel" />
            <vs-select-item  value="cancela" text="Absolute Cancel" />
          </vs-select>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data () {
    return {
      typeData: '',
      reason: '',
      options: [],
      activePrompt: false
    }
  },
  methods: {
    fetchReasons () {
      axios.get('api/reason')
        .then((response) => {
          this.options = response.data
        })
    },
    submitReason () {

      const data = {
        reason: this.reason,
        typeData: this.typeData
      }
      axios.put(`api/task/cancelTask/${this.$route.params.id}`, data)
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Task cancelled',
            icon: 'check_box',
            color: 'success'
          })

        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.$nextTick()
            .then(() => {
              const params = this.$route.query.projectId

                this.$store.dispatch('todo/fetchTaskForWorker', params)
                .then((response) => {
                        var finish = true;
                  this.taskList = response.data
                response.data.forEach(element => {

               if(element.status === "Not Completed" || element.status === "Cancelled" || element.status === "On Progress") finish = false

             });
             if(finish){


            this.$store
              .dispatch('project/sendmail', this.$route.query.projectId)
              .then((response) => {
              console.log(response.data)

              })
            }else{
                  this.$router.go()
            }
                })
              this.$store.dispatch('todo/fetchSingleTask', this.$route.params.id)


            })
        })
    }
  },
  mounted () {
    this.fetchReasons()
  }
}
</script>
